import { render, staticRenderFns } from "./OrderStatusDialog.vue?vue&type=template&id=a2d26632"
import script from "./OrderStatusDialog.vue?vue&type=script&lang=js"
export * from "./OrderStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports